// extracted by mini-css-extract-plugin
export default {"wait_while_is_authorizing":"SignInSettings_wait_while_is_authorizing__kfNsK"};